/**
 * profileContent — fatia de composição/apresentação.
 * Monta a lista de conteúdo (Posts | Vídeos) do usuário a partir dos hooks dos
 * domínios `community` (posts) e `communityVideos` (vídeos). As telas de perfil
 * importam SOMENTE este facade.
 */
export { default as UserContentList } from './components/UserContentList';
